import * as yup from "yup";

export const representasjonspunktSchema = yup.object({
	nord: yup.number().required(),
	øst: yup.number().required()
});

export type Representasjonspunkt = yup.Asserts<typeof representasjonspunktSchema>;
